import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Columns, Column, Stack, Text } from "braid-design-system";
import { translations } from "../../../components/SourcrRecruiter/.vocab/index.mjs";
import { sourcrRecruiterImg } from "./SourcrRecruiter.css.mjs";
const SourcrRecruiter = ({ name, profilePhotoUrl }) => {
  const { t } = useTranslations(translations);
  if (!name || !profilePhotoUrl) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Columns, { space: "xxsmall", alignY: "center", children: [
    /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(
      "img",
      {
        className: sourcrRecruiterImg,
        src: profilePhotoUrl,
        loading: "lazy"
      }
    ) }),
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
      /* @__PURE__ */ jsx(Text, { size: "xsmall", tone: "secondary", children: t("Recruited by") }),
      /* @__PURE__ */ jsx(Text, { size: "small", tone: "neutral", maxLines: 2, children: name })
    ] }) })
  ] });
};
export {
  SourcrRecruiter
};
